import React, { Component } from 'react';
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { Translate } from 'react-localize-redux';
import { DialogActions, Button, Grid, TextField, Typography } from '@material-ui/core';
import SuppliersSelector from '../../common/SupplierSelector';
import moment from 'moment'
import PartNumberSelector from '../../common/PartNumberSelector';
import Toaster from '../../common/Toaster';
import UserSelector from '../../common/UserSelector';

/**
 * Class component of form to create sacQuality
 *
 * @class FormView
 * @extends {Component}
 */
class FormView extends Component {
    constructor(props) {
        super(props)
        autoBind(this);
        this.state = {
            preparedBySelected: null,
            supplierSelected: null,
            supplierDevelopmentEngineer: null,
            problemDescription: "",
            partNumber: null,
            inventoryQuantity: "",
            reportedQuantity: "",
            startDate: moment(),
            showToaster: false,
            toasterMessage: null,
            toasterVariant: "",
        };
    };

    /**
     * Update property in state
     *
     * @param {*} property
     * @param {*} value
     * @memberof FormView
     */
    updateProperty(property, value) {
        this.setState({
            [property]: value
        })
    }

    /**
     * On seleted value
     */
    onSelected(propertyId, value) {
        this.setState({ [propertyId]: value });
    }

    /**
    * On change date arriveDate
    * @param {*} arriveDate 
    */
    onChangeRange(deliveryDate) {
        this.setState({
            delivery_date: deliveryDate,
        })
    }

    /**
     * call to action to save data and create sacQuality
     *
     * @memberof FormView
     */
    onSaveSacQuality() {
        if(this.hasInvalidValueQantity()){
            this.setState({
                showToaster:true,
                toasterMessage: <Translate id="qualityfailurereport.messageInventory"/>,
                toasterVariant: "error",
            })
        }
        else if(this.props.createSacQuality){
            this.props.createSacQuality(this.state)
                .then(response => {
                    this.props.history.push(`/sacsquality/${response.token}`)
                }).catch(() => {
                    this.setState({
                        showToaster: true,
                        toasterMessage: <Translate id="common.errorToSave" />,
                        toasterVariant: "error",
                    })
                });
            }
    }

    /**
     * Render Textfield disabled to edit
     *
     * @param {*} textFieldId
     * @param {*} translationTextFieldId
     * @param {boolean} [isMultiple=false]
     * @returns
     * @memberof FormView
     */
    renderTextFieldDisabled(textFieldId, translationTextFieldId, isMultiple = false) {
        let listIds = textFieldId.split('.');
        let value = '';
        if (listIds.length > 0) {
            value = this.state[listIds[0]] ? this.state[listIds[0]][listIds[1]] : '';
        }
        else {
            value = this.state[textFieldId];
        }
        return (
            <div >
                <TextField
                    id={textFieldId}
                    fullWidth
                    margin="normal"
                    value={value}
                    label={<span><Translate id={translationTextFieldId} /> *</span>}
                    onChange={(event) => { this.updateProperty(textFieldId, event.target.value) }}
                    className={isMultiple ? this.props.classes.textAreaField : this.props.classes.textField}
                    //Only textArea
                    multiline={isMultiple}
                    rows={isMultiple ? "4" : "1"}
                    variant={isMultiple ? "outlined" : 'standard'}
                    disabled
                />
            </div>
        )
    }

    /**
     * Render textFiel Enabled to edit
     *
     * @param {*} textFieldId
     * @param {*} translationTextFieldId
     * @param {boolean} [isMultiple=false]
     * @param {string} [type='text']
     * @returns
     * @memberof FormView
     */
    renderTextField(textFieldId, translationTextFieldId, isMultiple = false, type = 'text') {
        return (
            <div >
                <TextField
                    id={textFieldId}
                    fullWidth
                    margin="normal"
                    value={this.state[textFieldId] ? this.state[textFieldId] : ''}
                    label={<span><Translate id={translationTextFieldId} /> *</span>}
                    onChange={(event) => { this.updateProperty(textFieldId, event.target.value) }}
                    className={isMultiple ? this.props.classes.textAreaField : this.props.classes.textField}
                    type={type}
                    //Only textArea
                    multiline={isMultiple}
                    rows={isMultiple ? "4" : "1"}
                    variant={isMultiple ? "outlined" : 'standard'}
                />
            </div>
        )
    }

    /**
     * Method to validate required data is filled
     *
     * @returns
     * @memberof FormView
     */
    canBeSaved() {
        if(this.state.supplierSelected == null) return false;
        if(this.state.supplierDevelopmentEngineer === null) return false;
        if(this.state.problemDescription === "") return false;
        if(this.state.partNumber === null) return false;
        if(this.state.inventoryQuantity === "") return false;
        if(this.state.reportedQuantity === "") return false;
        return true;
    }

       /**
     * Has valid quantity
     */
    hasInvalidValueQantity() {
        /// Validar que la cantidad inventario no puede ser mayor a la cantiad reportada
        if(this.state.inventoryQuantity !== "" && this.state.reportedQuantity !== ""){
            let qualityInPlant = Number(this.state.inventoryQuantity);
            let qualityReport = Number(this.state.reportedQuantity);
            if(qualityInPlant < qualityReport){
                return true;
            }
            else
                return false;
        }
        else 
            return false;
    }

    /**
     * Render
     */
    render() {
        const { classes } = this.props;
        return (
            <Grid container spacing={24} style={{ paddingLeft: '80px', paddingRight: "100px", }}>
                <Grid item xs={6} >
                    <div className={classes.textField} >
                        <Typography variant="subtitle1" gutterBottom><Translate id="common.supplier"/> *</Typography>

                        <SuppliersSelector
                            className={classes.textField}
                            onSupplierSelected={(supplier) => { this.onSelected('supplierSelected', supplier) }}
                        />
                        <br />
                    </div>
                    <div className={classes.textField} >
                        <Typography variant="subtitle1" gutterBottom><Translate id="common.supplierDevelopmentEngineer"/> *</Typography>

                        <UserSelector
                            className={classes.textField}
                            onUserSelected={(engineer) => { this.onSelected('supplierDevelopmentEngineer', engineer) }}
                        />
                        <br />
                    </div>
                    {this.renderTextField('problemDescription', 'sacsQuality.descriptionSacQuality', true)}
                    <br />
                    <br />
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.textField} >
                        <Typography variant="subtitle1" gutterBottom><Translate id="common.partNumber"/> *</Typography>
                        <PartNumberSelector
                            className={classes.textField}
                            onPartNumberSelected={(partNumber) => { this.onSelected('partNumber', partNumber) }}
                        />
                    </div>
                    {this.renderTextFieldDisabled('partNumber.description', 'sacsQuality.materialDescription')}
                    {this.renderTextFieldDisabled('partNumber.measurementUnit', 'sacsQuality.measurementUnit')}

                    {this.renderTextField('inventoryQuantity', 'sacsQuality.inventoryQuantity', false, 'number')}
                    {this.renderTextField('reportedQuantity', 'sacsQuality.reportedQuantity', false, 'number')}

                </Grid>
                <Grid item xs={12} >
                    <DialogActions>
                        <Button
                            data-cy="btn-save"
                            type="button"
                            color="primary"
                            onClick={() => this.onSaveSacQuality()}
                            disabled={!this.canBeSaved() || this.props.isSaving}
                        >
                            {<Translate id="common.save" />}
                        </Button>
                        <Button onClick={() => { this.props.history.push(`/sacsquality`) }} color="secondary">
                            {<Translate id="common.cancel" />}
                        </Button>
                    </DialogActions>
                </Grid>
                <Toaster
                    message={this.state.toasterMessage}
                    open={this.state.showToaster}
                    variant={this.state.toasterVariant}
                    onClose={() => { this.setState({ showToaster: false }) }}
                />
            </Grid>
        )
    }
}


const viewStyles = theme => ({
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    textAreaField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
    footerForm: {
        display: "flex",
        paddingRight: "60px",
    },
    formControl: { margin: theme.spacing.unit },
    toolbar: {},
    searchInput: {},
    button: {},
    actionsToolbar: {},
    showingUsersCounter: {},
    grow: {},
    supplierBadge: {}
});

export default withRouter(withStyles(viewStyles, { withTheme: true })(FormView));